export const UPN_ESO_LOOKUP_MODES = {
	SELF_LOOKUP: 'self',
	MANAGER_LOOKUP: 'manager',
	HELP_DESK_LOOKUP: 'helpdesk',
};
